import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GraphicComponent} from './graphic.component';
import {LoaderModule} from '../loader/loader.module';

@NgModule({
  declarations: [GraphicComponent],
  imports: [
    CommonModule,
    LoaderModule
  ],
  exports: [
    GraphicComponent
  ]
})
export class GraphicModule {
}
